<template>
  <button class="btn" :type="nativeType" :class="classs" :disabled="disabled" @click="onClick">
    <slot />
  </button>
</template>
<script>
export default {
  name: 'BaseButton',
  props: {
    type: {
      type: String,
      default: 'primary',
    },
    nativeType: {
      type: String,
      default: 'button',
    },
    disabled: Boolean,
  },
  computed: {
    classs() {
      return [`btn-${this.type}`, { 'is-disabled': this.disabled }];
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="less" scoped>
.btn {
  width: 100%;
  height: 90px;
  border-radius: 4px;
  font-size: 32px;
  & + & {
    margin-top: 30px;
  }
  &.btn-primary,
  &.btn-submit {
    color: #fff;
    background: linear-gradient(130deg, #fc6242 0%, #f0403c 100%);
  }
  &.btn-default {
    color: #707076;
    background: #fff;
    border: 1px solid #e5e5e5;
  }
  &.btn-danger {
    color: #ff5159;
    background: rgba(255, 81, 89, 0.1);
    border: 1px solid #ff5159;
  }
  &.btn-warning {
    color: #ff5159;
    background: #ffffff;
    border: 1px solid #e5e5e5;
  }
  &.btn-cancel {
    color: #0078ff;
    background: #d9ebff;
    box-shadow: none;
  }
  &.is-disabled {
    color: #979799;
    background: #e5e5e5;
    box-shadow: none;
  }
  &.btn-new-default {
    color: #fff;
    background: #0078ff;
    box-shadow: none;
  }
}
</style>
